import {useQuery, useQueryClient} from '@tanstack/react-query';

import {fetchNewsDetail} from 'api/news';

const findItemInPages = (pages, id) => {
    if (!Array.isArray(pages) || !id) {
        return null;
    }

    for (let index = 0; index < pages.length; index += 1) {
        const page = pages[index];

        if (!page || !Array.isArray(page.items)) {
            continue;
        }

        const foundItem = page.items.find((item) => item && String(item._id || item.id) === String(id));

        if (foundItem) {
            return foundItem;
        }
    }

    return null;
};

export function useNewsDetail(id, initialItem = null) {
    const queryClient = useQueryClient();

    const cachedList = queryClient.getQueryData(['news-list']);
    const cachedItem = findItemInPages(cachedList && cachedList.pages, id);

    const query = useQuery({
        queryKey: ['news-detail', id],
        queryFn: () => fetchNewsDetail(id),
        enabled: Boolean(id),
        staleTime: 5 * 60 * 1000,
        cacheTime: 30 * 60 * 1000,
        placeholderData: initialItem || cachedItem || undefined
    });

    return {
        newsItem: query.data,
        error: query.error,
        isLoading: query.isLoading
    };
}
